import { Toaster } from "@bleu.builders/ui";
import * as React from "react";
import { Outlet, useLocation } from "react-router";

import { Link } from "#/components/Link";

export function Layout({ children }) {
  return (
    <>
      <Toaster position="top-right" />
      <div className="container relative flex align-middle lg:grid h-screen flex-col items-center justify-center lg:max-w-none lg:grid-cols-12 lg:px-0">
        <Logo />
        <DotsBackground />
        <div className="col-span-7 relative hidden h-full flex-col bg-muted py-10  md:px-24 xl:px-28 lg:flex dark:border-r">
          <div className="absolute inset-0 bg-primary z-10" />
          <div className="relative h-full flex justify-center flex-col z-50">
            {children}
          </div>
        </div>
        <div className="col-span-5 lg:p-8 pt-0 align-middle">
          <div className="mx-auto flex flex-col justify-center space-y-6 w-full">
            <Outlet />
            <p className="px-8 text-center text-sm text-muted-foreground">
              Ao continuar, você concorda com nossos <br />
              <Link
                to="https://clickfiscal.com.br/termos-de-uso"
                className="underline underline-offset-4 hover:text-primary"
              >
                Termos de Uso
              </Link>{" "}
              e{" "}
              <Link
                to="https://clickfiscal.com.br/politica-de-privacidade"
                className="underline underline-offset-4 hover:text-primary"
              >
                Política de Privacidade
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function DotsBackground() {
  return (
    <>
      <div className="absolute z-30 top-0 left-0 w-7/12">
        <img src="/images/dots.png" alt="Dots" className="" />
      </div>
      <div className="absolute z-30 bottom-0 left-0 w-7/12 rotate-180">
        <img src="/images/dots.png" alt="Dots" className="" />
      </div>
    </>
  );
}

function Logo() {
  return (
    <>
      <div className="lg:hidden mb-10">
        <img
          src="https://clickfiscal.com.br/wp-content/uploads/2022/08/cropped-logo-1.webp"
          alt="Authentication"
          className="block w-48 mx-auto dark:hidden"
        />
        <img
          src="/images/logo-dark.png"
          alt="Authentication"
          className="hidden dark:block w-48 mx-auto"
        />
      </div>
      <div className="absolute right-0 top-0 w-5/12 flex justify-center">
        <div className="w-48 pt-10 hidden lg:block">
          <img
            src="https://clickfiscal.com.br/wp-content/uploads/2022/08/cropped-logo-1.webp"
            alt="Authentication"
            className="block dark:hidden"
          />
          <img
            src="/images/logo-dark.png"
            alt="Authentication"
            className="hidden dark:block"
          />
        </div>
      </div>
    </>
  );
}

export function LoginFormContainer({
  message,
  children,
}: React.PropsWithChildren<{ message: string }>) {
  const pathname = useLocation().pathname;
  const isSignUp = pathname.includes("signup");
  const title = isSignUp
    ? "Comece a utilizar o Recuperar gratuitamente"
    : "Bem-vindo de volta ao Recuperar!";
  return (
    <>
      <div className="flex flex-col space-y-2 px-10">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <p className="text-muted-foreground text-sm">{message}</p>
      </div>
      <div className="flex ">
        <div className="w-full px-10">{children}</div>
      </div>
    </>
  );
}
